<template>
  <page :title="title" :breadcrumb="breadcrumb" :load="doInit">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-navigation-drawer permanent light width="100%" class="mavSmallMenu">
              <v-toolbar flat>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title class="title" v-if="newIntermediary">
                        New Intermediary
                      </v-list-tile-title>
                      <v-list-tile-title class="title" v-else>
                        {{ $store.state.adminInter.intermediary.intermediaryName }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-toolbar>
              <v-list class="pt-0">
                <v-divider></v-divider>
                <v-list-tile v-for="item in sideMenu" :key="item.name" :to="{ name: item.name }">
                  <v-list-tile-action v-if="item.name === 'interCommDiscFactors'">
                    <v-icon :class="isMatchRoute('reviewInterCommDiscFactors') ? 'primary--text':''">{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-action v-else>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content v-if="item.name === 'interCommDiscFactors'">
                    <v-list-tile-title :class="isMatchRoute('reviewInterCommDiscFactors') ? 'primary--text':''">{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content v-else>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md9>
          <transition name="slide-x-transition" mode="out-in">
            <router-view ></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      breadcrumb: [],
      sideMenu: [
        { name: 'reviewProfile', text: 'Profile', icon: 'mdi-account' }
      ],
      newIntermediary: false
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName',
      'checkAccess'
    ]),
    title() {
      if (this.newIntermediary) {
        return 'New Profile'
      } else {
        return 'Review Profile'
      }
    }
  },
  watch: {
    '$store.state.adminInter.intermediary.intermediaryName': function(value) {
      return this.$store.state.adminInter.intermediary.intermediaryName
    }
  },
  methods: {
    ...mapActions([
      'interMenuInit'
    ]),
    async doInit() {
      if (this.inter === 'new') {
        this.newIntermediary = true
      } else {
        await this.interMenuInit(this.inter)
        this.sideMenu.push({ name: 'reviewUsers', text: 'Users', icon: 'mdi-folder-account' })
        this.sideMenu.push({ name: 'reviewProducts', text: 'Products', icon: 'mdi-cube-outline' })
        this.sideMenu.push({ name: 'interCommDiscFactors', text: 'Commission/Discount', icon: 'mdi-sale' })
        this.breadcrumb = this.derieveBreadcrumbByName('intermediaries')
      }
      this.breadcrumb = this.derieveBreadcrumbByName('intermediaries')
      this.breadcrumb.push({
        name: 'reviewProfile',
        text: this.title
      })
    }
  },
  props: ['inter'],
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
.queryPnl {
  margin-top: 50px;
}
</style>
